import { Component, OnInit } from '@angular/core';
import { FeaturesFlagsV2Service } from 'src/app/core/services/features-flags-v2.service';

/**
 * Container component for tickets table that switches between v1 and v2 based on feature flag.
 */
@Component({
  selector: 'app-tickets-table-container',
  template: `
    @if (isLoading) {
      <mat-spinner>Loading tickets table</mat-spinner>
    }
    @if (!isLoading) {
      @if (!useV2TicketsTable) {
        <tickets-table></tickets-table>
      } @else {
        <app-tickets-table-v2></app-tickets-table-v2>
      }
    }
  `,
  standalone: false,
})
export class TicketsTableContainerComponent implements OnInit {
  useV2TicketsTable = false;
  isLoading = true;

  constructor(private featuresFlagsV2Service: FeaturesFlagsV2Service) {}

  ngOnInit() {
    this.featuresFlagsV2Service.featuresFlags$.subscribe((featuresFlags) => {
      this.useV2TicketsTable = featuresFlags.some((flag) => flag.feature === 'msp-direct-requests' && flag.isActive);
      this.isLoading = false;
    });
  }
}
